// import { combineReducers, configureStore } from "@reduxjs/toolkit";
// import rolePermissionReducer from "../features/rolePermissionsSlice";
// import permissionsReducer from "../features/permissionsSlice";
// import subscriptionReducer from "../features/subscriptionSlice";
// import { subscriptionListenerMiddleware } from "../features/subscriptionListenerMiddleware";
// import sessionReducer from "../features/sessionSlice";
// import branchReducer from "../features/branchSlice";
// import authReducer, { logout } from "../features/authSlice";

// // ✅ Combine all reducers properly
// const appReducer = combineReducers({
//   roleAccess: rolePermissionReducer,
//   permissions: permissionsReducer,
//   subscriptionData: subscriptionReducer,
//   session: sessionReducer,
//   branchList: branchReducer,
//   auth: authReducer,
// });

// // ✅ Correctly reset the state on logout
// const rootReducer = (state: any, action: any) => {
//   if (action.type === logout.type) {
//     state = undefined; // Reset entire state
//   }
//   return appReducer(state, action); // ✅ Call the combined reducer function
// };

// export const store = configureStore({
//   reducer: rootReducer, // ✅ Now Redux gets a valid reducer function
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware().prepend(subscriptionListenerMiddleware.middleware),
//   devTools: process.env.NODE_ENV !== "production",
// });

// // Infer the `RootState` and `AppDispatch` types
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import rolePermissionReducer from "../features/rolePermissionsSlice";
import permissionsReducer from "../features/permissionsSlice";
import subscriptionReducer from "../features/subscriptionSlice";
import { subscriptionListenerMiddleware } from "../features/subscriptionListenerMiddleware";
import sessionReducer from "../features/sessionSlice";
import branchReducer from "../features/branchSlice";
import authReducer, { logout } from "../features/authSlice";
import companyRegistrationReducer from "../features/companyRegistrationSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { expireTransform } from '../features/expireTransform'; // 🕒 20-min expiry transform
import paymentReducer from "../features/paymentSlice";

// ✅ Config for redux-persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['companyRegistration'],
  transforms: [expireTransform],
};

// ✅ Combine all reducers
const appReducer = combineReducers({
  companyRegistration: companyRegistrationReducer,
  roleAccess: rolePermissionReducer,
  permissions: permissionsReducer,
  subscriptionData: subscriptionReducer,
  session: sessionReducer,
  branchList: branchReducer,
  auth: authReducer,
     payments: paymentReducer,
});

// ✅ Global logout reset logic
const rootReducer = (state: any, action: any) => {
  if (action.type === logout.type) {
    state = undefined; // Clears all slices
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// ✅ Store setup with middleware + devtools + persist
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).prepend(subscriptionListenerMiddleware.middleware),
  devTools: process.env.NODE_ENV !== "production",
}, );

export const persistor = persistStore(store); // 🧠 Needed for PersistGate

// ✅ Types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
